<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showsnackbar" color="#00a972" right :timeout="timeout">
      {{msg}}
      <v-btn text @click="showsnackbar = false">
        <v-icon style="color:white;">mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <!-- <Filters /> -->
    <Blog v-if="dataretrived" v-bind:blogData="blogData" />
  </div>
</template>

<script>
import axios from "axios";
// import Filters from "./../Resources/Filters";
import Blog from "./../Blog/Blog";

export default {
  props: ["id"],
  components: {
    // Filters,
    Blog
  },
  data() {
    return {
      appLoading: false,
      showsnackbar: false,
      timeout: 5000,
      msg: null,
      dataretrived: false,
      blogData: null,
      ServerError: false
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      if (localStorage.getItem("token")) {
        axios({
          method: "GET",
          url: "/blog/get",
          headers: {
            "x-auth-token": localStorage.getItem("token")
          },
          params: {
            id: this.id
          }
        })
          .then(response => {
            this.appLoading = false;
            this.blogData = response.data.data;
            this.dataretrived = true;
          })
          .catch(err => {
            this.msg = err;
            this.ServerError = true;
          });
      } else {
        axios({
          method: "GET",
          url: "/blog/get",
          params: {
            id: this.id
          }
        })
          .then(response => {
            this.appLoading = false;
            this.blogData = response.data.data;
            this.dataretrived = true;
          })
          .catch(err => {
            this.msg = err;
            this.ServerError = true;
          });
      }
    }
  }
};
</script>

<style>
#home_bg {
  /* background-image: url("../../assets/home_header.png"); */
  /* background-repeat: no-repeat; */
  /* background-size: contain; */
  color: white;
}

@media only screen and (max-width: 800px) {
  #home_bg {
    /* background-image: url("../../assets/home_header.png"); */
    /* background-repeat: no-repeat; */
    background-size: cover;
    /* color: white; */
  }
}
</style>
